// Single source of truth for the "Last places!" badge logic (Stages page + Boutique).
export const DEFAULT_LOW_PLACES_THRESHOLD = 3;

export function getLowPlacesThreshold(content) {
  const v = content?.stages?.options?.low_places_threshold;
  return v === "" || v === null || v === undefined ? DEFAULT_LOW_PLACES_THRESHOLD : Number(v);
}

export function isLowPlaces({ places, taken, isFull, isClosed, threshold }) {
  const total = places || 0;
  if (total <= 0 || isFull || isClosed) return false;
  return total - (taken || 0) <= threshold;
}
